import IMask from './imask.js';
export { default as HTMLContenteditableMaskElement } from './controls/html-contenteditable-mask-element.js';
export { default as HTMLInputMaskElement, type InputElement } from './controls/html-input-mask-element.js';
export { default as HTMLMaskElement } from './controls/html-mask-element.js';
export { default as InputMask, type InputMaskElement } from './controls/input.js';
export { default as MaskElement } from './controls/mask-element.js';
export { default as ChangeDetails, type ChangeDetailsOptions } from './core/change-details.js';
export { type AppendTail, type TailDetails } from './core/tail-details.js';
export { DIRECTION, forceDirection, type Direction, type Selection } from './core/utils.js';
export { default as Masked, type AppendFlags, type ExtractFlags, type MaskedOptions, type MaskedState } from './masked/base.js';
export { default as MaskedDate, type DateMaskType, type MaskedDateOptions } from './masked/date.js';
export { default as MaskedDynamic, type DynamicMaskType, type MaskedDynamicOptions, type MaskedDynamicState } from './masked/dynamic.js';
export { default as MaskedEnum, type MaskedEnumOptions } from './masked/enum.js';
export {
  default as createMask,
  normalizeOpts,
  type AllFactoryStaticOpts,
  type FactoryArg,
  type FactoryConstructorOpts,
  type FactoryConstructorReturnMasked,
  type FactoryInstanceOpts,
  type FactoryInstanceReturnMasked,
  type FactoryOpts,
  type FactoryReturnMasked,
  type FactoryStaticOpts,
  type FactoryStaticReturnMasked,
  type NormalizedOpts,
  type UpdateOpts,
} from './masked/factory.js';
export { default as MaskedFunction, type MaskedFunctionOptions } from './masked/function.js';
export { default as MaskedNumber, type MaskedNumberOptions } from './masked/number.js';
export { default as MaskedPattern, type BlockPosData, type Definitions, type MaskedPatternOptions, type MaskedPatternState } from './masked/pattern.js';
export { type default as PatternBlock } from './masked/pattern/block.js';
export { default as ChunksTailDetails, type ChunksTailState } from './masked/pattern/chunk-tail-details.js';
export { default as PatternFixedDefinition, type PatternFixedDefinitionOptions } from './masked/pattern/fixed-definition.js';
export { default as PatternInputDefinition, type PatternInputDefinitionOptions, type PatternInputDefinitionState } from './masked/pattern/input-definition.js';
export { createPipe, pipe, PIPE_TYPE } from './masked/pipe.js';
export { default as MaskedRange, type MaskedRangeOptions } from './masked/range.js';
export { default as MaskedRegExp, type MaskedRegExpOptions } from './masked/regexp.js';
export { default as RepeatBlock, type RepeatBlockOptions } from './masked/repeat.js';

try { (globalThis as any).IMask = IMask; } catch {}
export default IMask;
